module.exports = __webpack_public_path__ + "media/images/logos/wine-moderation-03507581c1143281f1e6398d209cd173.png";